
export default {
  immobilisation: 1
}